function Gradient({ color1, color2 }) {
	const gradientStyle = {
		background: `linear-gradient(0deg, ${color1} 0%, ${color2} 100%)`,
		height: "264px",
		marginTop: "-264px",
	};

	return <div style={gradientStyle}></div>;
}

export default Gradient;
